import { FieldValues, UseControllerProps } from "react-hook-form";

// eslint-disable-next-line import/prefer-default-export
export const modificateRequiredRule = <T extends FieldValues>(
  initRules: UseControllerProps<T>["rules"]
): UseControllerProps<T>["rules"] => {
  const rules = initRules;

  if (rules?.required === true) {
    rules.required = "Обязательное поле";
  }

  return rules;
};
